import { useRef } from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import MovieCard from './MovieCard'
import { SkeletonRow } from './Skeleton'

const MovieRow = ({ title, eyebrow, items, loading, onReadMore }) => {
  const scroller = useRef(null)

  const scroll = (dir) => {
    const el = scroller.current
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: 'smooth' })
  }

  if (!loading && (!items || items.length === 0)) return null

  return (
    <section className='movie-row container'>
      <div className='row-head'>
        <div className='row-heading'>
          {eyebrow && <span className='eyebrow'>{eyebrow}</span>}
          <h2>{title}</h2>
        </div>
        <div className='row-nav'>
          <button onClick={() => scroll(-1)} aria-label='Scroll left'>
            <FiChevronLeft />
          </button>
          <button onClick={() => scroll(1)} aria-label='Scroll right'>
            <FiChevronRight />
          </button>
        </div>
      </div>

      {loading ? (
        <SkeletonRow />
      ) : (
        <div className='row-scroller' ref={scroller}>
          {items.map((item) => (
            <div className='row-item' key={item.id}>
              <MovieCard media={item} onReadMore={onReadMore} />
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

export default MovieRow
